import { getToken, setToken } from "@/lib/local"
import router from "@/router"
import store from "@/store"

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken("jubao_admin")

  if (!hasToken) {
    next(to.path === "/login" ? undefined : "/login")
    return
  }

  if (to.path === "/login") {
    next("/")
    return
  }

  if (store.state.permission.loaded) {
    const matchedRoute = router.match(to.path)
    next(matchedRoute.matched.length ? undefined : "/")
    return
  }

  try {
    const userInfo = await store.dispatch("user/getInfo")
    setToken("Id", userInfo.id)
    setToken("type", userInfo.role_id)
    store.commit("user/SET_TYPE", userInfo.role_id)

    const accessRoutes = await store.dispatch("permission/generateRoutes")
    router.selfaddRoutes(accessRoutes)

    const matchedRoute = router.match(to.path)
    if (!matchedRoute.matched.length) {
      next({ path: "/", replace: true })
      return
    }
    next({ ...to, replace: true })
  } catch (error) {
    console.error("加载用户菜单权限失败:", error)
    await store.dispatch("user/logOut")
    next("/login")
  }
})
